export default "__VITE_ASSET__CTsU5jdT__"